export const replaceSpecialCharacters = (str) => {
  return str.normalize('NFD').replace(/\p{Diacritic}|\p{Punctuation}|\p{Symbol}/gu, '')
}
